import React, { useContext, useState, useEffect } from "react";
//
import { StoreContext } from "../../../../../../store/StoreProvider";
//
import Act from "../../../../../../store/actions";
import CommonList from "../../common/CommonList";
import Selection from "../../../../../../common/components/input/Selection";
import {
  countOptions,
  SNA_ANALYTICS_TYPE,
} from "../../../../../../config/config.sna";

const StyledList = CommonList;
const AccordionDetailChildren = () => {
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { sna } = state;
  const { filter } = sna;
  const { nodeCountMeetAuthNew } = filter || {};

  // local state
  const [inputVal, setInputVal] = useState("");
  const [listItems, setListItems] = useState([]);

  const createItem = (key, label, value) => ({ key, label, value });

  useEffect(() => {
    let tmpListItems = countOptions.map(({ key, label }) =>
      createItem(key, label, key)
    );
    const snaTypeMethods = Object.values(SNA_ANALYTICS_TYPE)
      .filter(({ countMethod }) => countMethod)
      .map(({ key, label }) => createItem(key, label, key));

    tmpListItems = [...tmpListItems, ...snaTypeMethods];
    setListItems(tmpListItems);
  }, []);

  useEffect(() => {
    if (nodeCountMeetAuthNew?.change) {
      setInputVal(nodeCountMeetAuthNew.change);
    }
  }, [nodeCountMeetAuthNew]);

  const handleInputChange = (evt) => {
    const { value } = evt.target;
    setInputVal(value);
    dispatch({
      type: Act.SNA_FILTER_NODE_COUNT_MEET_AUTH_CHANGE_NEW,
      payload: value,
    });
  };

  return (
    <StyledList>
      <Selection
        options={listItems}
        size="normal"
        darkMode
        fullWidth
        inputProps={{
          value: inputVal,
          onChange: handleInputChange,
        }}
      />
    </StyledList>
  );
};

export default AccordionDetailChildren;
